import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './assets/locales/en.json';
import heTranslation from './assets/locales/he.json';
import frTranslation from './assets/locales/fr.json';

const resources = {
    en: {
        translation: enTranslation,
    },
    he: {
        translation: heTranslation,
    },
    fr: {
        translation: frTranslation,
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        // Default to English. Only an explicit choice — the language switcher
        // (cached in localStorage/cookie) or ?lng= in the URL — overrides it.
        // We no longer auto-detect the visitor's browser language.
        detection: {
            order: ['querystring', 'localStorage', 'cookie'],
            caches: ['localStorage', 'cookie'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
